"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var modals_1 = require("./../modals");
var AcknowledgementsComponent = (function () {
    function AcknowledgementsComponent(modalService) {
        this.modalService = modalService;
    }
    AcknowledgementsComponent.prototype.showAcknowledgement = function (ack) {
        var options = new modals_1.ModalOptions();
        options.title = 'Acknowledgements';
        options.notificationMessage = ack.message;
        this.modalService.showApiMessageModal(options);
    };
    return AcknowledgementsComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], AcknowledgementsComponent.prototype, "acknowledgements", void 0);
AcknowledgementsComponent = __decorate([
    core_1.Component({
        selector: 'acknowledgements',
        template: "<div *ngIf=\"acknowledgements\">     <span class=\"acknowledgement-link\" *ngFor=\"let ack of acknowledgements\" (click)=\"showAcknowledgement(ack)\">         View Missed Connection Acknowledgement     </span> </div>"
    }),
    __metadata("design:paramtypes", [modals_1.ModalService])
], AcknowledgementsComponent);
exports.AcknowledgementsComponent = AcknowledgementsComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/acknowledgements/acknowledgements.component.js